import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import CaseStudy from "../../../images/industries/education/pro_impact_1.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Globalmarket(props) {
  return (
    <section className="tekrevol_dark_bg  tekgrip_img_uper  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="example" data-text="Project Impact">
              <h2>
                Learn About Project Impact- A Revolutionary Educational App
                Developed by TekRevol
              </h2>
            </div>
            <p>
              The story of the S.E.L.F App by Project Impact, MS -driven by
              Tekrevol is a wonderful journey that narrates the process of
              creating our authority in educational app development. Experience
              the impact of our inventive products that have stirred the
              industry as the first modernized emotional intelligence assessment
              in educational settings. Click below to learn why we are a game
              changer in education.
            </p>
            <div className="btn_talk">
              <Link
                to="/case-studies/impact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                View Full Casestudy
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            <div className="tekgrip_tabs_image tek_impact">
              <LazyLoadImage
                src={CaseStudy}
                effect="blur"
                alt="CaseStudy"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Globalmarket;
